import { camelize } from '../utils/stringFormatter';
var msPattern = /^ms-/;
export default (function (name) {
  return camelize(name.replace(msPattern, 'ms-'));
});